<span *ngIf="header" class="field-header">{{header}}</span> 
<mat-form-field class="form-control" style="width: 100%" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <textarea
    matInput
    [placeholder]="label ? label : 'Text'"
    [formControl]="controlName"
    [ngClass]="header ? 'mt-2' : ''"
    [rows]="row"
  ></textarea>
  <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
  <mat-icon *ngIf="isValid()" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
</mat-form-field>
